import { render, staticRenderFns } from "./newWorkList.vue?vue&type=template&id=66d36d67&scoped=true&"
import script from "./newWorkList.vue?vue&type=script&lang=js&"
export * from "./newWorkList.vue?vue&type=script&lang=js&"
import style0 from "./newWorkList.vue?vue&type=style&index=0&id=66d36d67&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d36d67",
  null
  
)

component.options.__file = "newWorkList.vue"
export default component.exports